export const CurrencyPath = {
  BTC: 'https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd',
  USD: 'https://api.monobank.ua/bank/currency',
}
